var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.2171 13.2471C27.0653 13.2471 27.7592 13.9411 27.7592 14.7893V24.2891C27.7592 28.9156 25.446 32 20.0483 32H7.7109C2.31327 32 0 28.9156 0 24.2891V14.7893C0 13.9411 0.693981 13.2471 1.54218 13.2471H26.2171Z",
    fill: "#9D9DAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2047 3.56243V1.15663C21.2047 0.524341 20.6803 0 20.048 0C19.4157 0 18.8914 0.524341 18.8914 1.15663V3.4699H8.86723V1.15663C8.86723 0.524341 8.34289 0 7.71059 0C7.0783 0 6.55396 0.524341 6.55396 1.15663V3.56243C2.39007 3.94798 0.369806 6.43089 0.0613695 10.1167C0.0305259 10.5639 0.400649 10.9341 0.83246 10.9341H26.9262C27.3734 10.9341 27.7435 10.5485 27.6973 10.1167C27.3888 6.43089 25.3686 3.94798 21.2047 3.56243Z",
    fill: "#9D9DAC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5257 26.556L18.3845 25.4148C18.9705 24.5204 19.3252 23.4408 19.3252 22.2842C19.3252 19.1382 16.7652 16.5781 13.6191 16.5781C10.4731 16.5781 7.91309 19.1382 7.91309 22.2842C7.91309 25.4303 10.4731 27.9902 13.6191 27.9902C14.7758 27.9902 15.8553 27.6356 16.7498 27.0495L17.891 28.1907C18.1223 28.4221 18.4153 28.53 18.7083 28.53C19.0014 28.53 19.2944 28.4221 19.5257 28.1907C19.9729 27.7435 19.9729 27.0033 19.5257 26.556Z",
    fill: "#9D9DAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.6736612d00d2c04dad8bade491a953ca.svg";
export { ForwardRef as ReactComponent };